import React, { useEffect, useRef, useState } from "react";
import { Image } from "../componentIndex";
import StarIcon from '../../assets/images/dashboard/star.svg';
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import { Select } from "../../common/commonIndex";
import { useSearchParams } from "react-router-dom";
import { stringToHslColor, getDarkerHslColor } from '../../helper/extension';

const Reviews = ({ closeReviewScreen, reviewsProgressList, reviews }) => {
    const [searchParams] = useSearchParams();
    const [filterValue, setFilterValue] = useState('Newest');
    const [isLoading, setIsLoading] = useState(false);
    const [reviewsList, setFilteredReviews] = useState(reviews || []);
    const [reviewsProgress, setReviewsProgress] = useState(reviewsProgressList || []);
    const filterList = [
        { name: 'Newest', selected: false },
        { name: 'Highest', selected: false },
        { name: 'Lowest', selected: false }
    ];
    const popupRef = useRef(null)
    useEffect(() => {
        setFilteredReviews(reviews);
        setReviewsProgress(reviewsProgressList);
    }, []);

    // Date Format
    const formatDate = (timestamp) => {
        const date = new Date(Number(timestamp));
        return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
    };

    // Handle filter
    const handleChange = (value) => {
        setFilterValue(value);
        filterReviewList(value);
    };

    // Handle filter review list
    const filterReviewList = (selectedValue) => {
        const sortedReviews = [...reviewsList].sort((a, b) => {
            if (selectedValue === 'Newest') {
                return new Date(b.date) - new Date(a.date); // Sort by date descending
            } else if (selectedValue === 'Highest') {
                return b.review - a.review;
            } else {
                return a.review - b.review;
            }
        });
        setFilteredReviews(sortedReviews);
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closeReviewScreen();
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [closeReviewScreen]);

    return (
        <div className="fullscreen-overlay">
            <div className="fullscreen-overlay-content" ref={popupRef}>
                <div className="d-flex justify-content-start align-items-start mb-3" onClick={closeReviewScreen}>
                    <Image imgUrl={CloseIcon} altText="close" className="popup-close-icon cursor-pointer" />
                </div>

                {isLoading ? (
                    <div className="loader-content">
                        <div className="loader"></div>
                    </div>
                ) : reviewsList?.length > 0 ? (
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-5">
                            <div className="review-section">
                                <div className="rating-info">
                                    <Image imgUrl={StarIcon} altText="star" />
                                    <h2>{reviewsList[0]?.overall.toFixed(1) || '0.0'}</h2>
                                </div>
                                <div className="progress-content pb-md-4">
                                    {reviewsProgress.map((item, index) => (
                                        <div
                                            className="d-flex justify-content-between"
                                            key={index}
                                            style={{ marginBottom: '10px' }}
                                        >
                                            <span className="progress-name ">{item?.name?.replace('_', ' ')}</span>
                                            <div className="d-flex align-items-center max-width-140">
                                                <div style={{
                                                    maxWidth: '125px',
                                                    width: '100%',
                                                    backgroundColor: '#BDBDBD',
                                                    borderRadius: '2px',
                                                }}>
                                                    <div style={{
                                                        width: `${(item.review / 5) * 100}%`,
                                                        height: '7px',
                                                        backgroundColor: '#3059A5',
                                                        borderRadius: '2px'
                                                    }}></div>
                                                </div>
                                                <span className="review-progress">{item?.review?.toFixed(1)}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-7 pe-0">
                            <div className="reviewer-detail">
                                <div className="d-flex justify-content-between review-list">
                                    <h4 className="total-review">{reviewsList?.length} reviews</h4>
                                    <Select
                                        defaultValue="Newest"
                                        list={filterList}
                                        value={filterValue}
                                        isFilter
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={reviewsList?.length > 3 ? "scrollbar review-scrollbar" : ""}>
                                    <div className={reviewsList?.length > 3 ? "force-overflow" : ""}>
                                        {reviewsList.map((item, index) => (
                                            <div key={index}>
                                                <div className="d-flex align-items-start pb-2">
                                                    <div className="reviewer-profile">
                                                        {item.user_avatar_url ? (
                                                            <div
                                                                className="doctor-photo photo rounded-5 cursor-pointer"
                                                                style={{
                                                                    backgroundImage: `url(${item.user_avatar_url})`,
                                                                    backgroundSize: 'cover',
                                                                    backgroundPosition: 'center',
                                                                    backgroundRepeat: 'no-repeat'
                                                                }}
                                                            ></div>
                                                        ) : (
                                                            <div
                                                                className="doctor-photo photo rounded-5 cursor-pointer"
                                                                style={{
                                                                    backgroundColor: stringToHslColor(item.user_name?.charAt(0) || ""),
                                                                    border: `2px solid ${getDarkerHslColor(item.user_name?.charAt(0) || "")}`
                                                                }}
                                                            >
                                                                <p className="short-name">{item.user_name?.charAt(0) || ""}</p>
                                                            </div>
                                                        )}
                                                        {/* <div className="justify-content-center review-total mt-2">
                                                            <Image imgUrl={StarIcon} altText={'star'} className={''} />
                                                            <Image imgUrl={StarIcon} altText={'star'} className={''} />
                                                            <Image imgUrl={StarIcon} altText={'star'} className={''} />
                                                            <Image imgUrl={StarIcon} altText={'star'} className={''} />
                                                            <Image imgUrl={StarIcon} altText={'star'} className={''} />
                                                        </div> */}
                                                        {Array.from({ length: item?.overall }).map((_, index) => (
                                                            <span key={index}>
                                                                <Image imgUrl={StarIcon} altText={'star'} className={'user-total-review'}/>
                                                            </span>
                                                        ))}
                                                    </div>
                                                    <div className="ms-3">
                                                        <h4 className="reviewer-name">{item.user_name}</h4>
                                                        <p className="reviewer-date">{formatDate(item.date_created)}</p>
                                                        <p className="reviewer-description mb-0">{item.comments}</p>
                                                    </div>
                                                </div>
                                                <div className="divider my-3"></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="content">
                        No reviews yet
                    </div>
                )}
            </div>
        </div>
    );
};

export default Reviews;